import { useEffect, useRef, RefObject } from 'react';

type UseClickOutsideOptions = {
  enabled?: boolean;
  eventType?: 'mousedown' | 'click' | 'touchstart';
};

export function useClickOutside<T extends HTMLElement>(
  callback: () => void,
  options: UseClickOutsideOptions = {}
): RefObject<T> {
  const { enabled = true, eventType = 'mousedown' } = options;

  const ref = useRef<T>(null);

  useEffect(() => {
    if (!enabled) return;

    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (!ref.current) return;

      if (!ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener(eventType, handleClickOutside);

    return () => {
      document.removeEventListener(eventType, handleClickOutside);
    };
  }, [callback, enabled, eventType]);

  return ref;
}